<template>
  <div>
    <v-row>
      <v-card v-for="(res, i) in result" :key="i" style="margin:20px">
        <img
          style="padding:10px;max-width:400px;height:400px"
          :src="res.links[0].href"
        />
        <v-card-title style="max-width:400px;padding:2px">
          {{ res.data[0].title }}
        </v-card-title>
        <v-card-text style="max-width:400px;padding:2px">
          <p>Creater:{{ res.data[0].secondary_creator }}</p>
        </v-card-text>
      </v-card>
    </v-row>
    <v-dialog v-model="loading">
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.5);"
      >
        <v-layout justify-center align-center>
          <v-progress-linear
            indeterminate
            color="yellow darken-2"
          ></v-progress-linear>
          <br />
          <v-progress-linear indeterminate color="green"></v-progress-linear>
          <br />
          <v-progress-linear indeterminate color="teal"></v-progress-linear>
          <br />
          <v-progress-linear indeterminate color="cyan"></v-progress-linear>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["query"],
  data: function() {
    return {
      result: null,
    };
  },
  created: async function() {
    this.loading = true;
    let resp = await axios.get(
      `https://images-api.nasa.gov/search?q=&media_type=image`
    );
    this.result = resp.data.collection.items;
    for (var i = 0; i < 100000000; i++);
    this.loading = false;
  },
  watch: {
    query: async function(val) {
      this.loading = true;
      let resp = await axios.get(
        `https://images-api.nasa.gov/search?q=${val}&media_type=image`
      );
      this.result = resp.data.collection.items;
      for (var i = 0; i < 100000000; i++);
      this.loading = false;
    },
  },
  methods: {},
};
</script>

<style></style>
